export enum AnswerType {
    Reply = 'reply',
    ReplyDisposition = 'replyDisposition',
    LinkNext = 'linkNext',
    LinkNextDisposition = 'linkNextDisposition',
    Link = 'link',
    PanmanSurvey = 'panmanSurvey',
    YougovWelcomeSurvey = 'yougovWelcomeSurvey',
}
